var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCancel16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_cancle_16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24808",
    "data-name": "\\uC0AC\\uAC01\\uD615 24808",
    width: 16,
    height: 16,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_7",
    "data-name": "\\uD569\\uCE58\\uAE30 7",
    d: "M-5904.639,50.009a.6.6,0,0,1,0-.851l2.974-2.974-2.974-2.974a.6.6,0,0,1,0-.849.6.6,0,0,1,.849,0l2.975,2.974,2.974-2.974a.6.6,0,0,1,.851,0,.6.6,0,0,1,0,.849l-2.975,2.975,2.975,2.974a.6.6,0,0,1,0,.849.6.6,0,0,1-.851,0l-2.974-2.973-2.975,2.975a.6.6,0,0,1-.425.176A.6.6,0,0,1-5904.639,50.009Z",
    transform: "translate(5908.852 -38.186)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel16);
export default __webpack_public_path__ + "static/media/icon_cancel_16.e9c14e2fadf7f795e3788d5a8aaf1aea.svg";
export { ForwardRef as ReactComponent };